import type { TimeSeriesTrackTarget } from '../types';

export const getTimeSeriesTrackTarget = async ({
  familyId,
}: {
  familyId: string;
}): Promise<TimeSeriesTrackTarget> => {
  try {
    const response = await fetch(
      `/api/mixone/api/v1/track/${familyId}/performance/benchmark/timeseries?period=weekly&baseline=avg_comp&period_range_from=0&period_range_to=51`,
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch time series for track target: ${response.statusText}`,
      );
    }

    const data = await response.json();

    return {
      targetPercentage: data.target_percentage,
      username: data.username,
      unit: data.unit,
      countryCode: data.country_code,
      lastUpdated: data.last_updated_time,
      baselineData: data.baseline_data.map(
        (dataPoint: { unit_number: number; stream_count: number }) => ({
          unitNumber: dataPoint.unit_number,
          streamCount: dataPoint.stream_count,
        }),
      ),
    };
  } catch (error) {
    console.error('Error fetching time series for track target:', error);

    throw error;
  }
};
